import { Link } from 'react-router-dom';
import { hotList, site } from '@/mocks/site';

export default function HotRanking() {
  return (
    <section className="mx-auto max-w-content px-4 md:px-6 py-14 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <div className="mb-6 flex items-end justify-between">
            <div>
              <span className="mb-2 flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
                <i className="ri-fire-line"></i>
                今日热榜
              </span>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                吃瓜群众最关心的六件事
              </h2>
            </div>
            <Link
              to="/collections"
              className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700 sm:flex"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <ol className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {hotList.map((item) => (
              <li key={item.slug}>
                <Link
                  to={`/article/${item.slug}`}
                  className="group flex items-center gap-4 px-4 py-4 transition-colors hover:bg-background-100 md:px-5"
                >
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                      item.rank <= 3
                        ? 'bg-accent-100 text-accent-900'
                        : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {item.rank}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-sm font-medium leading-snug text-foreground-900 group-hover:text-primary-600 transition-colors md:text-base">
                      {item.title}
                    </span>
                  </span>
                  <span className="flex shrink-0 items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-fire-line text-primary-500"></i>
                    {item.heat}
                  </span>
                </Link>
              </li>
            ))}
          </ol>
        </div>

        <aside className="lg:col-span-1">
          <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-shield-check-line text-xl"></i>
            </span>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
              我们怎么整理一条瓜
            </h3>
            <ol className="mt-5 space-y-4 text-sm text-foreground-700">
              <li className="flex gap-3">
                <span className="font-heading font-bold text-secondary-700">01</span>
                <span>锁定最早的公开爆料源头，记录发布时间。</span>
              </li>
              <li className="flex gap-3">
                <span className="font-heading font-bold text-secondary-700">02</span>
                <span>收集各方回应、录音、截图，逐条标注出处。</span>
              </li>
              <li className="flex gap-3">
                <span className="font-heading font-bold text-secondary-700">03</span>
                <span>交叉比对矛盾点，写成可核对的时间线。</span>
              </li>
              <li className="flex gap-3">
                <span className="font-heading font-bold text-secondary-700">04</span>
                <span>后续进展以补充条目追加，不做悄悄删改。</span>
              </li>
            </ol>
            <p className="mt-5 border-t border-secondary-200 pt-5 text-xs leading-relaxed text-foreground-600">
              {site.disclaimer}
            </p>
          </div>
        </aside>
      </div>
    </section>
  );
}